@if (
    !user ||
    (!user.avatar &&
        (!user.prename ||
            !user.lastname ||
            user.prename == '' ||
            user.lastname == ''))
) {
    <rr-icon name="user" class="defaultuser"></rr-icon>
} @else if (user && !user.avatar && user.prename != '' && user.lastname != '') {
    <div class="defaultuser tiny">
        {{ user!.prename[0] }}{{ user!.lastname[0] }}
    </div>
} @else if (user!.avatar === 1) {
    <img
        class="avatar"
        [src]="serverurl + '/user/avatar?r=' + user.refreshtoken"
        alt="User Avatar"
    />
}
